import React from 'react';
import Header from '../header/Header';
import Aside from '../aside/Aside';
import DiamondMenuColumn from '../diamondMenuColumn/DiamondMenuColumn';
//import MarqueeTextMenu from '../marqueeTextMenu/MarqueeTextMenu';
import MarqueeContainer from '../marqueeContainer/MarqueeContainer';
import Home from '../home/home';
import About from '../secondLevelComponents/about/About';
import Contact from '../secondLevelComponents/contact/Contact';
import Experiments from '../secondLevelComponents/experiments/Experiments';
import Projects from '../secondLevelComponents/projects/Projects';
import Longitude from '../secondLevelComponents/longitude/Longitude';

import useAppStore from '../../useAppStore'; 

import './layout.css';
const Layout = ({ children, viewTitle, isViewOpen, open, setOpen, title}) => {
  const getViewTitle = useAppStore((state) => state.viewTitle);
  const getIsViewOpen = useAppStore((state) => state.isViewOpen);

  return (
    <div className={`grid grid-rows-5 h-screen layoutGrid ${getViewTitle === 'Home' || getViewTitle.length === 0 ? 'layoutHome' : 'layoutNotHome'} `}>     
      <div className="row-span-5">
          <Header />
      </div>
      <div className="disclaimer row-span-5">
         <Aside className='disclaimerContainer'/>
      </div>
      
      <div className={`row-span-5 diamondMenuContainer border-l border-r`} > 
         <DiamondMenuColumn className='diamondMenuContainer'/> 
      </div>
      <div className="row-span-5 border-r content-stretch">
         <MarqueeContainer/>
      </div>
      <div className="mainContent h-screen row-span-5"> 
      {(() => { 
        switch (getViewTitle) {
        case 'Home':
          return <Home />
        case 'Projects':
          return <Projects />
        case 'Experiments':
          return <Experiments />
        case 'Contact':
          return <Contact />
        case 'About':
          return <About />
        case 'Longitude':
          return <Longitude />
        default:
          return <Home />
       }
      })()}
      {/**  <Home /> toggling the property in app.js so i can change views here children*/}
      </div>
    </div>
  );
};

export default Layout;